module.exports = "/_dynamic/_next/static/images/500.background-fc071222bb1393b6b3ecd2752c96b8b5.png";